import { render, staticRenderFns } from "./MrpaEnableAssigneeForeignOrganization.vue?vue&type=template&id=5a859734&"
import script from "./MrpaEnableAssigneeForeignOrganization.vue?vue&type=script&lang=js&"
export * from "./MrpaEnableAssigneeForeignOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports